<template>
    <select style="width:100%"></select>
</template>

<script>
  import $ from 'jquery'
  import 'select2/dist/js/select2.full'


  // Russian
  function ending (count, one, couple, more) {
    if (count % 10 < 5 && count % 10 > 0 &&
      count % 100 < 5 || count % 100 > 20) {
      if (count % 10 > 1) {
        return couple;
      }
    } else {
      return more;
    }

    return one;
  }

  const ru = {
    errorLoading: function () {
      return 'Невозможно загрузить результаты';
    },
    inputTooLong: function (args) {
      var overChars = args.input.length - args.maximum;

      var message = 'Пожалуйста, введите на ' + overChars + ' символ';

      message += ending(overChars, '', 'a', 'ов');

      message += ' меньше';

      return message;
    },
    inputTooShort: function (args) {
      var remainingChars = args.minimum - args.input.length;

      var message = 'Пожалуйста, введите ещё хотя бы ' + remainingChars +
        ' символ';

      message += ending(remainingChars, '', 'a', 'ов');

      return message;
    },
    loadingMore: function () {
      return 'Загрузка данных…';
    },
    maximumSelected: function (args) {
      var message = 'Вы можете выбрать не более ' + args.maximum + ' элемент';

      message += ending(args.maximum, '', 'a', 'ов');

      return message;
    },
    noResults: function () {
      return 'Совпадений не найдено';
    },
    searching: function () {
      return 'Поиск…';
    },
    removeAllItems: function () {
      return 'Удалить все элементы';
    }
  };

  $.fn.select2.amd.define('VueDataAdapter',
    [
      'select2/utils',
      'select2/data/array',
      'select2/data/minimumInputLength'
    ],
    function (Utils, ArrayAdapter, MinimumInputLength) {
      const VueDataAdapter = function($element, options) {
        VueDataAdapter.__super__.constructor.call(this, $element, options);
        this._query = this.options.get('queryData');
      };

      Utils.Extend(VueDataAdapter, ArrayAdapter);

      VueDataAdapter.prototype.query = function(params, callback) {
        if (this._timer) {
          clearTimeout(this._timer);
          this._timer = undefined;
        }

        this._timer = setTimeout(() => {
          this._query(params.term, (data) => {
            this._timer = undefined;
            callback({
              results: data || []
            });
          })
        }, 500);
      };

      return Utils.Decorate(VueDataAdapter, MinimumInputLength);
    }
  );

  export default {
    name: "SelectPicker",
    props: {
      placeholder: String,
      multiple: Boolean,
      selection: [Array, Object],
      value: [Array, Object, Number]
    },

    computed: {
      selected() {
        return this.value || this.selection;
      },

      values() {
        let data;

        if (this.multiple) {
          data = (this.selected || []).map(e => ({
            id: e.id,
            text: e.name,
            selected: true
          }));
        }
        else {
          data = [];

          if (this.selected && this.selected.id) {
            data = [{
              id: (this.selected || {}).id,
              text: (this.selected || {}).name,
              selected: true
            }]
          }
        }

        return data;
      }
    },

    watch: {
      selection() {
        this._renderSelect();
      },

      value() {
        this._renderSelect();
      }
    },

    mounted() {
      const VueDataAdapter = $.fn.select2.amd.require('VueDataAdapter');

      const vm = this;

      this.elem = $(this.$el).select2({
        multiple: this.multiple,
        placeholder: this.placeholder,
        minimumInputLength: 0,
        minimumResultsForSearch: Infinity,
        dataAdapter: VueDataAdapter,
        data: this.values,
        language: ru,
        templateResult: (e) => {
          if (e.level) {
            return $(`<span class="level-${e.level}">${e.text}</span>`);
          }
          else {
            return $(`<span>${e.text}</span>`);
          }
        },
        queryData: (text, done) => {
          this.$emit('query', {text, done});
        },
        theme: 'default'
      });

      this.elem.on('change', function () {
        const data = vm.elem.find(':selected').toArray().map(e => ({
          id: e.value,
          name: e.text
        }));
        vm.$emit('update:selection', vm.multiple ? data: data[0]);
        vm.$emit('input', vm.multiple ? data: data[0]);
        vm.$emit('change');
      });
    },

    destroyed() {
      $(this.$el).off().select2('destroy');
    },

    methods: {
      _renderSelect() {
        const vm = this;

        console.log('rendering', this.values);

        this.elem.empty();
        this.values.map(v => {
          this.elem.append(new Option(v.text, v.id, true, true));
        });

        this.elem.off('change').trigger('change').on('change', () => {
          const data = vm.elem.find(':selected').toArray().map(e => ({
            id: e.value,
            name: e.text
          }));

          console.log('new values', data);
          vm.$emit('update:selection', vm.multiple ? data: data[0]);
          vm.$emit('input', vm.multiple ? data: data[0]);
          vm.$emit('change');
        });
      }
    }
  }

</script>

<style lang="scss">
  @import '../../../node_modules/select2/dist/css/select2.css';
  @import 'theme/layout';

  .level-1 {
    font-weight: bold;
  }
  .level-2 {
    padding-left: 20px;
  }
  .level-3 {
    padding-left: 40px;
  }
  .level-4 {
    padding-left: 60px;
  }
  .level-5 {
    padding-left: 80px;
  }
  .level-6 {
    padding-left: 100px;
  }

  .select2-container {
    position: relative;
    margin: 0;
    width: 480px;
    cursor: pointer;
  }
</style>
